import { render } from "./RevenueGrowth.vue?vue&type=template&id=65184285&scoped=true"
import script from "./RevenueGrowth.vue?vue&type=script&lang=js"
export * from "./RevenueGrowth.vue?vue&type=script&lang=js"

import "./RevenueGrowth.vue?vue&type=style&index=0&id=65184285&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65184285"]])

export default __exports__